module.exports = __webpack_public_path__ + "static/img/pic_bottom@2x.692b2670.png";